import { ChannelTypeEnum, ScaningData } from "../../types";
import EventBus from "../event-bus";
const scaningHook = new EventBus<{
  channelType: ChannelTypeEnum;
  data: ScaningData;
}>("scaningHook");

export default scaningHook;
